import { AjaxStreamCallback, AjaxWrapper, HttpMethod } from 'generic/ajaxWrapper'

export interface AnalyticsChatResponse {
  message?: string
  done?: boolean
  error?: string
}

export type AnalyticsChatCallback = (response: AnalyticsChatResponse | null) => void

/**
 * Stream analytics chat response from backend
 */
export const streamAnalyticsChatResponse = (
  communityId: string,
  payload: any,
  callback: AnalyticsChatCallback
) => {
  const url = `${AjaxWrapper.getServerUrl()}/ai/${communityId}/chat`

  const responseParser: AjaxStreamCallback = (success: boolean, chunk: string) => {
    if (!chunk) {
      callback({ done: true })
      return
    }

    if (!success) {
      callback({
        done: true,
        error: chunk || 'Stream connection failed',
      })
      return
    }

    // Parse SSE format: "data: {...}\n\ndata: {...}\n\n"
    const lines = chunk.split('\n')
    lines.forEach((line) => {
      if (line.startsWith('data: ')) {
        try {
          const jsonStr = line.substring(6) // Remove "data: " prefix
          const data = JSON.parse(jsonStr)
          callback(data)
        } catch (e) {
          // Ignore parse errors for incomplete chunks
        }
      }
    })
  }

  AjaxWrapper.stream(url, HttpMethod.POST, payload, responseParser)
}
